import PropTypes from "prop-types";
import { useFormState } from "react-hook-form";
const SimonSuccess = ({
  children
}) => {
  const formStateProxy = useFormState();
  const formState = {
    isSubmitSuccessful: formStateProxy.isSubmitSuccessful
  };
  return formState.isSubmitSuccessful && children;
};
SimonSuccess.propTypes = {
  children: PropTypes.node.isRequired
};
SimonSuccess.defaultProps = {};
export {
  SimonSuccess as default
};
